import React, { useEffect, useState } from 'react';
import { RouteComponentProps, useHistory, withRouter } from 'react-router-dom';
import { notification, Row, Col, Form, Card } from 'antd';
import DF from 'DisplayFramework';
import DataGrid from 'components/DataGrid';
// import OfferInput from './PropDetail/OfferInput';
import { DataGridProps, DataGridColDef } from 'components/DataGrid/DataGrid';
import {
  ProposalListResponse,
  FindPropByAnyRefOrStatusOrDateParams,
  findPropByAnyRefOrStatusOrDate,
} from 'services/proposal';
import {
  FindFinModificationByAnyRefOrStatusParams,
  findFinModificationByAnyRefOrStatus,
} from 'services/fincontract';
import FormInput from 'components/FormInput';
import ButtonOperation from 'components/ButtonOperation';
import { toCurrency } from 'utils/utils';
import Title from 'components/Title';
import numeral from 'numeral';

type PropListProps = RouteComponentProps & {
  onSelect?: (item: ProposalListResponse) => void;
  hideExtraAction?: boolean;
  hideFilters?: boolean;
  phase?: string;
  mfid?: number;
  tpauthid?: number;
  tpauthdetailid?: number;
  search?: boolean;
  prcode?: string;
  PropOrProd?: string;
  refetch?: boolean;
  hideAction?: boolean;
  clientname?: string;
  setdelet?: any;
  delet?: boolean;
  flagPropWithCtreference?: boolean;
} & Pick<DataGridProps<any>, 'rowSelection'>;

const MyRequests = (props: PropListProps) => {
  const search = props.location.search;
  const params = new URLSearchParams(search);

  const phase = params.get('phase');

  const [listOfData, setListOfData] = useState<any[]>([]);

  const lphase = phase ?? props?.PropOrProd ?? 'PROPOSAL';
  const { onSelect, rowSelection } = props;
  const initialSearchParams: FindPropByAnyRefOrStatusOrDateParams = {
    branchid: '' as any,
    mfid: props.mfid ?? 0,
    tpauthdetailid: props.tpauthdetailid ?? 0,
    tpauthid: props.tpauthid ?? 0,
    brokername: '',
    clientname: props.clientname ?? '',
    ctphase: props.phase ?? '',
    ctreference: '',
    ctstatus: '',
    datemax: '',
    datemin: '',
    marketingid: '' as any,
    network: '',
    offerid: '' as any,
    prcode: props.prcode ?? '',
    propreference: '',
    tprefbroker: '',
    tpreference: '',
    flagPropWithCtreference: props.flagPropWithCtreference ?? false,
    tpidclient: Number(localStorage.getItem('tpid')),
    ctexternalpropref: '',
    ctexternalrefde: '',
  };

  const initialSearchValues = {
    ctreference: '',
    ctrid: 0,
    modevent: 'PREFINRENE',
    modstatus: '',
    modtype: 'SIMUL',
    creationuserid: Number(localStorage.getItem('userid')),
  };

  numeral('').format('0a');

  const [searchParamsFinModifications, setSearchParamsFinModifications] =
    useState<FindFinModificationByAnyRefOrStatusParams>(initialSearchValues);

  const history = useHistory();
  const [searchs, setsearchs] = useState<any>(true);
  const [searchParams, setSearchParams] =
    useState<FindPropByAnyRefOrStatusOrDateParams>({
      ...initialSearchParams,
    });

  const [loading, setLoading] = useState(false);

  const [advencedFilter, setAdvencedFilter] = useState(true);

  const getData = async () => {
    setListOfData([]);
    setLoading(true);
    const listFindFinModification = await findFinModificationByAnyRefOrStatus(
      searchParamsFinModifications
    )
      .then(
        (res) =>
          res?.list?.map((finModif) => {
            const inputString = finModif.modcomment;

            let firstPart = '';
            let secondPart = finModif.modcomment;
            try {
              // Utiliser split pour diviser la chaîne en deux parties

              if (inputString.indexOf('-') !== -1) {
                const parts = inputString.split('-');

                // Assigner les parties à des variables
                firstPart = parts[0];
                secondPart = parts[1];
              }
            } catch (error) {
              firstPart = '';
              secondPart = finModif.modcomment;
            }

            return {
              chassisno: firstPart,
              productType: secondPart,
              offeridlabel: '',
              ctcomment: finModif.modcomment,
              ctfinancedamount: '' as any,
              status: finModif.modstatus === 'USED' ? 'ACCEPT' : 'INPROG',
              statuslabel:
                finModif.modstatus === 'INIT'
                  ? 'Being process'
                  : 'Accepted by the bank ',
            };
          }) || []
      )
      .catch((err) => []);

    const listContracts = await findPropByAnyRefOrStatusOrDate({
      ...searchParams,
    })
      .then(
        (res) =>
          res?.list?.map((contract) => {
            let chassino = '';
            try {
              const inputString = contract.ctcomment;
              const parts = inputString?.split(' : ');
              if (parts) {
                const extractedString = parts[parts.length - 1];
                chassino = extractedString;
              }
            } catch (error) {
              chassino = '';
            }

            return {
              chassisno: chassino,
              productType: contract.offeridlabel,
              offeridlabel: contract.offeridlabel,
              ctcomment: contract.ctdescription,
              ctfinancedamount: contract.ctfinancedamount,
              status: contract.ctstatus === 'PREFIN' ? 'ACCEPT' : 'INPROG',
              statuslabel:
                contract.ctstatus === 'PREFIN'
                  ? 'Accepted by the bank '
                  : 'Being process',
            };
          }) || []
      )
      .catch((error) => {
        notification.error({
          description: error.message,
          message: 'Proposal Service is not available',
        });
        return [];
      });

    setListOfData([...listFindFinModification, ...listContracts]);
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const columns: DataGridColDef<any>[] = [
    {
      dataIndex: 'chassisno',
      render: (chassisno, record) => chassisno,
      width: 30,
      fixed: 'left',
    },
    {
      dataIndex: 'productType',
      width: 70,
    },
    {
      dataIndex: 'ctcomment',
      filtrable: false,
      width: 70,
      ellipsis: true,
    },
    {
      comcode: 'offeridlabel',
      dataIndex: 'offerid',
      width: 70,
      ellipsis: true,
      render: (value, record) => record.offeridlabel,
    },

    {
      dataIndex: 'ctfinancedamount',
      width: 50,
      render: (val, record) => {
        return record.ctfinancedamount === '' ? ('' as any) : toCurrency(val);
      },
    },

    {
      comcode: 'statuslabel',
      render: (statuslabel, record) => (
        <span
          style={{
            color: record.status === 'ACCEPT' ? 'green' : 'black',
            fontWeight: record.status === 'ACCEPT' ? 'bold' : 'normal',
          }}
        >
          {' '}
          {record.statuslabel}
        </span>
      ),
      width: 40,
      fixed: 'right',
    },
  ];

  return (
    <DF.Provider pagcode="myRequests">
      <Card>
        <Row justify="start">
          <Title comcode="myRequests" level={2} color="#243882" />
        </Row>
        <Row justify="end">
          <Col span={8}>
            <Form>
              <FormInput name="searchInput" />
            </Form>
          </Col>
          <Col>
            <ButtonOperation
              type="primary"
              comcode="filterAvencee"
              onClick={() => {
                setAdvencedFilter(!advencedFilter);
              }}
            />
          </Col>
        </Row>
        <DataGrid
          titleComcode="request_List"
          scroll={{ x: 2000, y: 500 }}
          dataSource={listOfData}
          rowKey={(record) => record.ctrid}
          columns={columns}
          isLoading={loading}
          componentName="proposal_list"
          initialSearchValues={initialSearchParams}
          rowSelection={rowSelection}
          pagination={false}
          extractData="ProposalList"
          hideExtraAction={props.hideExtraAction}
          hideFilters={advencedFilter}
        />
      </Card>
    </DF.Provider>
  );
};

export default withRouter(MyRequests);
